import { Box, Card, Typography } from "@mui/material";

const ServiceItem = (props) => {
  return (
    <Card elevation={0}>
      <Box px={4} pt={4}>
        <Typography variant="h5" mb={3}>
          {props.title}
        </Typography>
        <Box style={{ marginRight: "-32px" }}>
          <img
            src={props.imgUrl}
            alt="service"
            style={{ display: "block", marginLeft: "auto", maxWidth: "90%" }}
          ></img>
        </Box>
      </Box>
    </Card>
  );
};

export default ServiceItem;
